import { render, staticRenderFns } from "./share.vue?vue&type=template&id=ccba68d8&scoped=true&lang=pug"
import script from "./share.vue?vue&type=script&lang=coffee"
export * from "./share.vue?vue&type=script&lang=coffee"
import style0 from "./share.vue?vue&type=style&index=0&id=ccba68d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccba68d8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/opt/build/repo/site/components/globals/btn/btn.vue').default,Squircle: require('/opt/build/repo/site/components/globals/squircle/index.vue').default})
